import React from 'react'
import { useBogo } from '@mc/bogo-utils'
import { useFreeTrial } from '@mc/free-trial'
import { withI18nContext } from '@mc/i18n'
import { i18nInstance } from '../../i18n/i18nInstance'
import { BogoLegal } from './legals/BogoLegal'
import { BundleLegal } from './legals/BundleLegal'
import { RegularLegal } from './legals/RegularLegal'
import { SubmitLegal } from './legals/SubmitLegal'
import { TrialLegal } from './legals/TrialLegal'

interface EmailCaptureLegalProps {
  className?: string
  isGift?: boolean
  kind?: 'email-capture' | 'submit'
  isBundleProduct?: boolean
  ctaText?: string
}

const EmailCaptureLegalComponent = ({
  className = '',
  isGift,
  kind = 'email-capture',
  ctaText,
  isBundleProduct,
}: EmailCaptureLegalProps) => {
  const { isBogoOfferEligible } = useBogo({ isGift })
  const { trial } = useFreeTrial({ isGift })
  const classes = `${className} mc-mb-4 mc-text-small`

  if (isBogoOfferEligible) {
    return <BogoLegal className={classes} />
  }

  if (isBundleProduct) {
    return <BundleLegal className={classes} />
  }

  if (trial.eligible) {
    return <TrialLegal className={classes} />
  }

  if (kind === 'submit') {
    return <SubmitLegal className={classes} ctaText={ctaText} />
  }

  return <RegularLegal className={classes} />
}

export const EmailCaptureLegal = withI18nContext(i18nInstance)(
  EmailCaptureLegalComponent,
)
